import TagListContainer from './TagList';

export default TagListContainer;
